import { Pipe, PipeTransform } from '@angular/core';
import { Material } from '../classes/material.class';
import { PlanningMaterial } from '../classes/planning-material.class';

@Pipe({
    name: 'planningMaterials',
})
export class PlanningMaterialsPipe implements PipeTransform {
    transform(planningMaterials: PlanningMaterial[] | null, materialsById: Map<number, Material>): Material[] {
        return [...(planningMaterials ?? [])]
            .sort((a, b) => (b.quantity ?? 0) - (a.quantity ?? 0))
            .map(pm => materialsById?.get(pm.material_id))
            .filter(Boolean);
    }
}
